<template>
  <p class="activity__details-item">
    <Icon :id="icon" />
    <span>{{ text }}</span>
  </p>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'ActivityDetail',
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  components: { Icon },
}
</script>
